import React from "react"
import ReactDOM from "react-dom"
import App from "./components/App"
import "./index.css"

if (window.location.protocol !== "https:" && window.location.hostname !== "localhost") {
  window.location.protocol = "https:";
}

ReactDOM.render(<App />, document.getElementById("root"))



// WEBPACK FOOTER //
// ./src/index.js